<p>duplicate-migration-certificate works!</p>
